module.exports = __webpack_public_path__ + "img/abo10.1353ce5b.jpg";